module.exports = __webpack_public_path__ + "97af8cfd06adc52d56ad466d73abecaa.pdf";